import React from 'react';
import { Card, Typography } from 'antd';
// Components
import DigitalAgreementSettings from './components/DigitalAgreementSettings/DigitalAgreementSettings';
// Styles
import styles from './CbDigitalAgreementSettings.module.scss';

const { Title } = Typography;

/** Platform-wide digital agreement setting, under CB Settings in the Campaigns menu */
const CbDigitalAgreementSettings = (): JSX.Element => (
  <div className={styles.root}>
    <Title level={2}>Digital Agreement</Title>
    <Card>
      <DigitalAgreementSettings />
    </Card>
  </div>
);

export default CbDigitalAgreementSettings;
